"use client";

import React from "react";
import { GuideElement, type GuideElementProps } from "../BaseDemoElement";
import { Menu } from "lucide-react";
import { useResponsiveCardStyle, type CardSize } from "@/hooks/use-responsive-card-style";

interface ShowHeaderTabsStepProps
  extends Omit<GuideElementProps, "title" | "description" | "icon" | "targetSelector"> {
  size?: CardSize;
}

export function ShowHeaderTabsStep({ size = "md", ...rest }: ShowHeaderTabsStepProps) {
  // Get responsive styles using centralized hook
  const cardStyle = useResponsiveCardStyle(size, "default");

  return (
    <GuideElement
      title="Navigate between sections"
      description="Use the header tabs to switch between Profile, Creators, Campaigns, and Campaign Tasks."
      icon={Menu}
      targetSelector='[data-guide-step="header-tabs"]'
      position="bottom"
      spotlight
      forceSpotlight
      offset={{ x: 0, y: 12 }}
      showArrow
      disableAutoScroll
      computePosition={({ getSpotlightBounds, defaultWidth, defaultHeight, margin }) => {
        const s = getSpotlightBounds();
        const ox = rest.offset && typeof rest.offset.x === 'number' ? rest.offset.x : 0;
        const oy = rest.offset && typeof rest.offset.y === 'number' ? rest.offset.y : 0;
        return {
          top: s.top + s.height + margin + oy,
          left: s.left + s.width / 2 - defaultWidth / 2 + ox,
          transform: 'none',
          tooltipWidth: defaultWidth,
          tooltipHeight: defaultHeight,
        };
      }}
      style={{ ...cardStyle, ...(rest.style || {}) }}
      {...rest}
    />
  );
}

export default ShowHeaderTabsStep;
